import { Component, OnInit, ViewChild } from '@angular/core';
import { DatatableComponent } from '../../shared/datatable/datatable.component';
import { FormHeaderComponent, ICustomButton, IFormHeaderSearch, FormHeaderSearchEventsEnum } from '../../shared/form-header/form-header.component';
import { GceInvoiceDms, GceInvoicePerson, GceClinic, GceLookUpOptions, GceInvoicePersonCompensation } from '../../entities/gce-management';
import { MatDialog } from '@angular/material';
import { GceManagementService } from '../../services/gce-management.service';
import { TranslateService } from '@ngx-translate/core';
import { AlertDialogService } from '../../services/alert-dialog.service';
import { Confirm } from "../../dialogs/confirm-dialog/confirm-dialog.component";
import { FormComponent } from '../../shared/form/form.component';
import { Alert } from '../../dialogs/alert-dialog/alert-dialog.component';
import * as moment from 'moment';
import { GceDialogInvoiceDmsFormComponent } from '../dialogs/gce-dialog-invoice-dms-form/gce-dialog-invoice-dms-form.component';
import { GceDialogCalculateBillingComponent } from '../dialogs/gce-dialog-calculate-billing/gce-dialog-calculate-billing.component';
import { PermissionService } from '../../services/permission.service';
import { GcePerformanceCalculationDetail } from '../../entities/gce-management/gce-performance-calculation-detail';
import { GcePerformanceCalculationDetracts } from '../../entities/gce-management/gce-performance-calculation-detracts';
import { GceDialogPerformanceCalculationDetailComponent } from '../dialogs/gce-dialog-performance-calculation-detail/gce-dialog-performance-calculation-detail.component';
import { AuthGuardService } from '../../services';
import { show } from '../../entities/gce-management/gce-management';
import { IConditionalFormatting } from '../../directives/conditional-formatting.directive';
import { LoaderService } from '../../loader/loader.service';
const dateFormatDate = "YYYY-MM-DD";
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-gce-invoices-dms',
  templateUrl: './gce-invoices-dms.component.html',
  styleUrls: ['./gce-invoices-dms.component.css']
})
export class GceInvoicesDmsComponent implements OnInit {
  @ViewChild(DatatableComponent, { static: false }) table: DatatableComponent;
  @ViewChild('formHeader', { static: false }) formHeader: FormHeaderComponent;
  @ViewChild('formData', { static: false }) formData: FormComponent;
  columns: any[] = [];
  medics: any[] = [];
  invoices: GceInvoiceDms[] = [];
  invoicesBkp: GceInvoiceDms[] = [];
  limitRows: number;
  heightMainList: number;
  currentRow: any;
  newRow: any;
  editing: boolean = false;
  keyColumn: any = {};
  customButtons: ICustomButton[] = [];
  openRightPanel: boolean = false;
  role: string = '';
  dm: string = '';
  usr: string = '';
  fromDate: string = this.gceService.dataRepoGceEnvironment.getFromDate();
  toDate: string = this.gceService.dataRepoGceEnvironment.getToDate();
  showb: boolean = false;
  writePermission: boolean;
  nerr: number = 0;
  nop: number = 0;
  isAdmin: boolean = false;
  invoice: GceInvoiceDms;
  conditionalFormattingConfig: IConditionalFormatting;

  details: GcePerformanceCalculationDetail[];
  detracts: GcePerformanceCalculationDetracts[];

  constructor(private dialog: MatDialog, private gceService: GceManagementService,
    private translateService: TranslateService,
    private alertDialog: AlertDialogService, private auth: AuthGuardService, private loaderService: LoaderService, private http: HttpClient) {
    this.conditionalFormattingConfig = {
      formulas: [{
        field: 'flg_doc_emesso',
        rule: '== true',
        classes: ['row-touched']
      }]
    };

    this.writePermission = PermissionService.checkPermission("CGE_EFTT");

    this.customButtons.push({
      matTooltipCode: 'GCE.GCEINVOICEPERSON.BUTTONS.EXPORTTOEXCEL.REPORTPRESTAIONITOOLTIP',
      labelCode: 'GCE.GCEINVOICEPERSON.BUTTONS.EXPORTTOEXCEL.REPORTPRESTAIONITOOLTIP',
      img: 'assets/img/excel.png',
      class: 'custom-button',
      clickFunction: this.simpleExportToExcel.bind(this)
    });
  }

  simpleExportToExcel() {
    console.log('export to excel %o', this.currentRow);
    if (!(this.currentRow == null) && this.currentRow.idfatturazione > 0) {
      this.gceService.getPerformanceCalculationDetailGeneric(this.currentRow.idfatturazione, this.currentRow.mese, this.currentRow.cod_clinica).subscribe(ret => {
        this.gceService.simpleExportInvoiceDetailToExcel(this.currentRow, ret['details'], ret['detracts']);
      }, err => {
        this.showb = false;
        window.alert('Errore nel recupero delle informazioni di dettaglio per la fattura selezionata.');
      });
    }
    else {
      window.alert('Selezionare una liquidazione per esportare il report medico semplificato.');
    }
  }

  exportAllToExcel() {
    console.log('export All to excel %o', this.invoices);
    this.gceService.exportAllToExcel(this.invoices);
  }

  calcValuesForReport() {

  }

  ngOnInit() {
    this.limitRows = Math.floor((window.innerHeight - 269) / 31); //269 340
    this.heightMainList = window.innerHeight - 188; //188 259
    this.columns = GceInvoiceDms.getStructure();
    this.showb = true;
    this.invoicesBkp = [];

    let usr = this.auth.getUser();
    if (usr != null) {
      this.role = usr['ruolo'];
      this.dm = usr['clinica'];
      if (usr['nomeCompleto'] != null && usr['nomeCompleto'].length > 0) {
        this.usr = usr['nomeCompleto'];
      }
      else {
        if (usr['email'] != null && usr['email'].length > 0) {
          this.usr = usr['email'];
        }
      }
    }
    if (this.role != null && (this.role.toLowerCase() == 'amministratore' || this.role.toLowerCase() == 'amministratore dp' || this.role.toLowerCase() == 'hr medici')) {
      this.isAdmin = true;
    }
    console.log('USER %o', usr);
    this.gceService.loadDataForInvoicesDms(this.fromDate, this.toDate).subscribe((dataResult: { persons: GceInvoicePerson[], invoices: GceInvoiceDms[] }) => {
      //manage column based on logged profile

      this.columns.forEach(column => {

        if (column.primaryKey) {
          this.keyColumn = column;
        }
        if (column.reference) {
          let lookUpOptions: GceLookUpOptions;
          if (column.reference.entity == "GceInvoicePerson") {
            lookUpOptions = this.gceService.getLookUpAndOptions(this.gceService.dataRepoInvoicePersons, column.reference);
          }
          if (lookUpOptions) {
            column.lookUp = lookUpOptions.lookUp;
            column.options = lookUpOptions.options;
          }
        }
      });
      let colcp = [];
      this.columns.forEach(column => {
        let vis = false;
        if (column.roles != null) {
          column.roles.forEach(r => {
            if (r.toLowerCase() == this.role.toLowerCase())
              vis = true;
          });
        }
        else {
          vis = true;
        }
        if (vis == true) {
          colcp.push(column);
        }
      });

      this.columns = colcp;
      console.log("columns %o", this.columns);
      this.invoices = dataResult.invoices;
      //san text

      this.invoicesBkp = [...this.invoices];
      this.showb = false;
      //get medics
      this.gceService.getAllInvoicePersons().subscribe(m => { this.medics = m });
    }, err => {
      this.invoicesBkp = [];
      this.showb = false;
    });
  }

  onEdit() {
    this.openDialogInvoiceForm(this.currentRow);
  }

  onSave() {
    console.log('onSave');
  }

  onDelete() {
    console.log('onDelete');
  }

  onSearch(searchFilter: IFormHeaderSearch) {

    if (searchFilter.event === FormHeaderSearchEventsEnum.INPUT_CHANGE) {
      let filterValues = searchFilter.filter.split(" ").filter(a => !!a);
      console.log("onSearch %o filterValue %o", searchFilter, filterValues);

      this.invoices = this.invoicesBkp.filter((item: GceInvoiceDms) => {
        for (let key in item) {
          //console.log('Key %o item %o', key, item[key]);
          if (!!item[key]) {
            /*
            if (!!(item[key] as GceInvoicePerson).idfatturazione) {
              //??

              if ((<GceInvoicePerson>item[key]).descrizione.split(" ").filter(val => {
                return filterValues.filter(fv => val.toLowerCase().indexOf(fv.toLowerCase()) != -1).length > 0;
              }).length >= filterValues.length) {
                return true;
              }
            }
            if (!!(item[key] as GceClinic).code_c) { //??
             
              if ((<GceClinic>item[key]).legalentity.split(" ").filter(val => {
                return filterValues.filter(fv => val.toLowerCase().indexOf(fv.toLowerCase()) != -1).length > 0;
              }).length >= filterValues.length) {
                return true;
              }
            } else {
              if (item[key] !== null && item[key] !== undefined && item[key].toString().toLowerCase().indexOf(searchFilter.filter) != -1) {
                console.log('FIND ?');
                return true;
              }
            }
            */

            if (!!(item[key] as GceInvoicePerson).idfatturazione) {
              for (let key2 in item[key]) {
                if (key2 == 'descrizione') {

                  if (item[key][key2] != null && item[key][key2].toString().toLowerCase().indexOf(searchFilter.filter) >= 0) {
                    console.log('GceInvoicePerson key2 %o item %o value %o', key2, item[key][key2].toString().toLowerCase(), searchFilter.filter);

                    return true;
                  }
                }
              }
            }
            if (!!(item[key] as GceClinic).code_c) {

              for (let key2 in item[key]) {

                if (key2 == 'code_c' || key2 == 'nome') {

                  if (item[key][key2] != null && item[key][key2].toString().toLowerCase().indexOf(searchFilter.filter) >= 0) {
                    console.log('GceClinic key2 %o item %o value %o', key2, item[key][key2].toString().toLowerCase(), searchFilter.filter);
                    return true;
                  }
                }
              }
            }

            if (key == 'id') {
              if (item[key].toString().toLowerCase().indexOf(searchFilter.filter) >= 0)
                return true;
            }
            //if (item[key] != null && item[key] != undefined && item[key].toString().toLowerCase().indexOf(searchFilter.filter) >= 0) {
            //console.log('FIND %o', item);
            //return true;
            //}
          }
        }
        return false;
      });
    } else {
      if (searchFilter.event === FormHeaderSearchEventsEnum.FROM_CHANGE) {
        let mfd = moment(searchFilter.fromDate);
        let mtd = moment(searchFilter.toDate);
        this.fromDate = mfd.format(dateFormatDate);
        if (mtd.diff(mfd, 'days') > mfd.daysInMonth() || mtd.isBefore(mfd)) {
          this.toDate = mfd.endOf('month').format(dateFormatDate);
        }
      }
      if (searchFilter.event === FormHeaderSearchEventsEnum.TO_CHANGE) {
        let mfd = moment(searchFilter.fromDate);
        let mtd = moment(searchFilter.toDate);
        this.toDate = mtd.format(dateFormatDate);
        if (mtd.diff(mfd, 'days') > mtd.daysInMonth() || mtd.isBefore(mfd)) {
          this.fromDate = mtd.startOf('month').format(dateFormatDate);
        }
      }
      if (this.fromDate && this.toDate) {
        //console.log("search %o %o", this.fromDate, this.toDate);
        this.gceService.getInvoicesDmsFromToGeneric(this.fromDate, this.toDate).subscribe((invoices: GceInvoiceDms[]) => {
          this.invoices = invoices;
          this.invoicesBkp = [...this.invoices];
        });
      }
    }

    this.table.offset = 0;
  }

  onToggle(selectedColumns) {
    console.log("onToggle %o %o", selectedColumns);
    this.columns.map(item => {
      item.show = selectedColumns.indexOf(item.columnDef) != -1;
    });
  }

  onChangeRow(row) {
    console.log("onChangeRow %o", row);
    this.currentRow = row;
    this.editing = false;
  }

  onRestore(event) {
    console.log("onRestore %o", event);
    this.clear();
  }

  onAction(event) {
    console.log("onAction %o", event);
  }

  onCloseForm(event) {
    console.log("onCloseForm %o", event);
    this.clear();
  }

  onOpenDialog(args) {
    console.log("onOpenDialog %o", args);

  }

  onCustomActionClick(event) {
    console.log("onCustomActionClick %o", event);
   // this.gceService.confirmInvoice(invoice).subscribe((d) => {
    if (this[event.field.callback]) {
      this[event.field.callback](event.row);
    }
  }

  filterClinics(dm: any, clinics: any) {
    let mydm = dm.substr(0, 3);
    console.log('filter clinics %o with dm %o', clinics, mydm);
    let ret = [];

    for (let a = 0; a < clinics.length; a = a + 1) {
      if (clinics[a].code_c == mydm)
        ret.push(clinics[a]);
    }
    return ret;
  }

  onDblClickRow(row) {
    //this.clear();
    this.openDialogInvoiceForm(row);
  }

  clear() {
    console.log('clear');
    this.currentRow = null;
    this.openRightPanel = false;
    this.editing = false;
  }

  openDialogInvoiceForm(invoice: GceInvoiceDms) {

    console.log("openDialogInvoiceDmsForm");
    let dialogRef = this.dialog.open(GceDialogInvoiceDmsFormComponent, {
      width: "90%",
      height: "90%",
      disableClose: true,
      data: { invoice: invoice, role: this.role, usr: this.usr, nerr: this.nerr, nop: this.nop }
    });
    dialogRef.afterClosed().subscribe((result: { invoice: GceInvoiceDms, saved: boolean, removed?: boolean }) => {
      console.log('result from dialog %o', result);
      if (result != null && result.saved) {

        for (let a = 0; a < this.invoices.length; a = a + 1) {
          if (this.invoices[a].idfatturazione == result.invoice['idfatturazione'] && this.invoices[a].idarea == result.invoice['idarea']) {
            console.log('find the invoices %o', result.invoice);
            this.invoices[a] = result.invoice;
          }
        }
        this.invoices = [...this.invoices];
      }
      this.clear();
    });
  }

  openDialogCalculateBilling() {
    /*
    console.log("openDialogCalculateBilling");
    let dialogRef = this.dialog.open(GceDialogCalculateBillingComponent, {
      width: "500px",
      height: "auto",
      disableClose: true,
      data: { month: this.toDate }
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      //aggiornare dati
      console.log("result %o", result);
      this.showb = true;
      this.gceService.loadDataForInvoicesDms(this.fromDate, this.toDate).subscribe((dataResult: { persons: GceInvoicePerson[], invoices: GceInvoiceDms[] }) => {
        //manage column based on logged profile
        this.invoices = dataResult.invoices;
        this.invoicesBkp = [...this.invoices];
        this.showb = false;
      }, err => {
        this.invoicesBkp = [];
        this.showb = false;
      });
    });
    */
  }

  sendReport(invoice: GceInvoiceDms) {

  }

  confirmInvoice(invoice: GceInvoiceDms) {
    console.log("confirmInvoice %o", invoice);
    this.showb = true;
    this.gceService.calcDmsInvoice(invoice).subscribe(ret => {
      this.showb = false;
       if (ret != null) {
        for (let a = 0; a < this.invoices.length; a = a + 1) {
          if (this.invoices[a].idfatturazione == ret['idfatturazione'] && this.invoices[a].idarea == ret['idarea']) {
           
            this.invoices[a] = ret;
          }
        }
        this.invoices = [...this.invoices];
      }
    }, err => {
      this.showb = false;
    });
  }

   confirmInvoiceHR(invoice: GceInvoiceDms) {
    console.log("confirmInvoiceDMS %o", invoice);
    this.showb = true;
    this.gceService.confirmInvoiceDMS(invoice).subscribe(ret => {
      this.showb = false;
       if (ret != null) {
        for (let a = 0; a < this.invoices.length; a = a + 1) {
          if (this.invoices[a].idfatturazione == ret['idfatturazione'] && this.invoices[a].idarea == ret['idarea']) {
           
            this.invoices[a] = ret;
          }
        }
        this.invoices = [...this.invoices];
      }
    }, err => {
      this.showb = false;
    });
  }


  openDialogPerformanceCalculationDetail(invoice: GceInvoiceDms) {

  }
}
